<template>
  <div v-if="usuario" class="mt-4">
    <button @click="$emit('volver')" class="btn btn-secondary mb-3"><font-awesome-icon :icon="['fas', 'arrow-left']" /> Volver Atrás</button>
    <div class="row">
      <div class="col-md-auto">

        <div class="card mb-3">
          <div class="card-body text-dark text-center">
            <p><strong><font-awesome-icon :icon="['fas', 'user']" /> Nombre:</strong> {{ usuario.nombre }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'user']" /> Apellido:</strong> {{ usuario.apellido }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'id-card']" /> Identificación:</strong> {{ usuario.identificacion }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'birthday-cake']" /> Fecha de Nacimiento:</strong> {{ usuario.fecha_nacimiento }} ({{ usuario.edad }} años)</p>
            <p><strong><font-awesome-icon :icon="['fas', 'map-marker-alt']" /> Dirección:</strong> {{ usuario.direccion }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'phone']" /> Teléfono:</strong> {{ usuario.telefono }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'envelope']" /> Email:</strong> {{ usuario.email }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'file-medical']" /> Receta Médica:</strong> {{ usuario.receta_medica }}</p>
            <p><strong><font-awesome-icon :icon="['fas', 'heartbeat']" /> Estado:</strong> {{ usuario.estado }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <ul class="list-group">
          <li v-for="dispensacion in usuario.dispensaciones" :key="dispensacion.id" class="list-group-item d-flex justify-content-between align-items-center">
            <span><font-awesome-icon :icon="['fas', 'calendar-alt']" /> {{ dispensacion.fecha_dispensacion }}</span>
            <span class="badge badge-primary badge-pill">{{ dispensacion.cantidad_entregada }} unidades</span>
          </li>
        </ul>
        <gestion-dispensacion :usuario="usuario" />
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-4">
    <p><font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin" /> Cargando detalles del usuario...</p>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from '@/axios';
// Asegúrate de importar la librería de iconos
import '@fortawesome/fontawesome-free/css/all.css';
import gestionDispensacion from '../Dispensacion/gestionDispensacion.vue';
import { useStore } from 'vuex';
export default {
  
  props: {
    usuarioId: Number
  },
  components: {
    gestionDispensacion
  },
  setup(props) {
    const usuario = ref(null);
    const store = useStore();
    const clubActual = store.getters.getClubActual;

    const fetchUsuario = async () => {
      try {
          const response = await axios.get(`/api/usuario-medicinal/${props.usuarioId}`, {
          params: {
            club_id: clubActual.id
          }
        });
        usuario.value = response.data;
        //ajustar fecha de nacimiento a formato dd/mm/yyyy
        usuario.value.fecha_nacimiento = new Date(usuario.value.fecha_nacimiento).toLocaleDateString('es-ES');
        //contar cuantos años tiene el usuario
        const hoy = new Date();
        const edad = hoy.getFullYear() - new Date(usuario.value.fecha_nacimiento).getFullYear();
        usuario.value.edad = edad;
      } catch (error) {
        console.error('Error al obtener detalles del usuario medicinal:', error);
      }
    };

    onMounted(fetchUsuario);

    return {
      usuario,
      clubActual
    };
  }
};
</script>

<style scoped lang="scss">
/* Estilos para el componente */
@import '@/scss/custom-bootstrap.scss';

.container {
  max-width: 800px;
}
.card {
  background-color: $light;
  border-color: $app-primary;
}
.list-group-item {
  background-color: $light;
}
.badge-primary {
  background-color: $app-primary;
}
</style> 